__turbopack_context__.v({
  "container": "_9bZ9SG_container",
});
